import * as Yup from "yup";

export const CarContracrAddFormValidation = Yup.object({
  document_number: Yup.string("شماره سند را وارد کنید").required(
    "شماره سند را باید وارد نمایید",
  ),
  buyer_usage_kilometer: Yup.number()
    .nullable()
    .typeError("عدد وارد نمایید")
    .positive("عدد وارد نمایید")
    .integer(),
  seller_usage_kilometer: Yup.number()
    .nullable()
    .typeError("عدد وارد نمایید")
    .positive("عدد وارد نمایید")
    .integer(),
  price: Yup.number()
    .nullable()
    .typeError("عدد وارد نمایید")
    .positive("عدد وارد نمایید")
    .integer(),
  // lastname :Yup.string("نام خانوادگی را وارد کنید")
  //     .required("نام خانوادگی  را وارد کنید"),
  // id_card_number : Yup.number('کد ملی بدون خط تیره وارد کنید')
  //     .required("کد ملی را وارد نمایید"),
  // email : Yup.string().email("ایمل وارد نمایید"),
  // credit : Yup.number('عدد وارد نمایید')
});
